/* Assets/recommended-categories.js */
(function () {
  // ======= USTAWIENIA (edytujesz TYLKO tutaj) =======
  const SECTION_TITLE = "Polecane kategorie";

  // Podmień # na właściwe linki
  const CATS = [
    { label:"Strój na rozpoczęcie roku szkolnego", url:"#",
      subLinks:[{label:"Wygodne spodnie",url:"#"}, {label:"Swetery z kolekcji Basic",url:"#"}] },
    { label:"Strój na WF", url:"#",
      subLinks:[{label:"Koszulki sportowe",url:"#"}, {label:"Spodenki sportowe",url:"#"},{label:"Strój na WF dla dziewczynki",url:"#"},{label:"Strój na WF dla chłopca",url:"#"}] },
    { label:"Ubrania do szkoły", url:"#",
      subLinks:[{label:"Bluzki i T-shirty",url:"#"}, {label:"Spodnie chino",url:"#"}, {label:"Zestawy dresowe",url:"#"}] },
    { label:"Strój galowy", url:"#",
      subLinks:[{label:"Okazjonalne koszule",url:"#"}, {label:"Eleganckie spodnie",url:"#"}] },
    { label:"Kurtki przeciwdeszczowe", url:"#",
      subLinks:[{label:"Kurtki przeciwdeszczowe Chłopięce",url:"#"}, {label:"Kurtki przeciwdeszczowe Dziewczęce",url:"#"}] },
    { label:"Kurtki dla dzieci", url:"#",
      subLinks:[{label:"Kurtki zimowe",url:"#"}, {label:"Kurtki przejściowe",url:"#"}, {label:"Kamizelki i Bezrękawniki",url:"#"},{label:"Kurtki bomberki",url:"#"}, {label:"Kurtki jeansowe",url:"#"}] },
    { label:"Bluzy dla dzieci", url:"#",
      subLinks:[{label:"Z kapturem",url:"#"}, {label:"Rozpinane",url:"#"}] },
    { label:"Koszule dla dzieci", url:"#", subLinks:[] },
    { label:"Koszulki dla dzieci", url:"#", subLinks:[] },
    { label:"Spodnie dla dzieci", url:"#",
      subLinks:[{label:"Jeansy",url:"#"}, {label:"Dresowe",url:"#"}] },
    { label:"Legginsy dziecięce", url:"#",
      subLinks:[{label:"Gładkie",url:"#"}, {label:"Wzorzyste",url:"#"}] },
    { label:"Bielizna dziecięca", url:"#",
      subLinks:[{label:"Majtki",url:"#"},{label:"Bokserki",url:"#"}, {label:"Podkoszulki",url:"#"}] },
    { label:"Czapki dziecięce", url:"#",
      subLinks:[{label:"Zimowe",url:"#"}, {label:"Przejściowe",url:"#"}] },
    { label:"Swetry dla dzieci", url:"#",
      subLinks:[{label:"Wkładane przez głowę",url:"#"}, {label:"Zapinane",url:"#"}] },
    { label:"Skarpety dziecięce", url:"#", subLinks:[] },
    { label:"Stroje kąpielowe dla dzieci", url:"#",
      subLinks:[{label:"Stroje kąpielowo jednoczęściowe",url:"#"},{label:"Stroje kąpielowe dwuczęściowe",url:"#"}, {label:"Czepki kąpielowe",url:"#"}] },
    { label:"Szlafroki dziecięce", url:"#", subLinks:[] },
    { label:"Rękawiczki dziecięce", url:"#", subLinks:[] },
    { label:"Szaliki dziecięce", url:"#", subLinks:[] },
    { label:"Ubrania jeansowe dla dzieci", url:"#",
      subLinks:[{label:"Jeansy",url:"#"}, {label:"Katany",url:"#"}] },
    { label:"Ubranka na roczek dla chłopca", url:"#", subLinks:[] },
    { label:"Sukienki okazjonalne dla dziewczynki", url:"#", subLinks:[] },
    { label:"Ubranie do przedszkola", url:"#", subLinks:[] },
    { label:"Ubranie dla pierwszoklasisty", url:"#", subLinks:[] },
    { label:"Prezenty dla dzieci", url:"#",
      subLinks:[{label:"Do 100 zł",url:"#"}, {label:"Do 200 zł",url:"#"}] },
    { label:"Prezenty dla dziewczynek", url:"#",
      subLinks:[{label:"Zestawy dresowe",url:"#"}, {label:"Moda",url:"#"}] },
    { label:"Prezenty dla chłopców", url:"#",
      subLinks:[{label:"Zestawy dresowe",url:"#"}, {label:"Moda",url:"#"}] },
  ];
  // ======= / USTAWIENIA =======

  // Minimalne style można zostawić w theme.css lub wstrzyknąć tutaj:
  function injectOnce(id, css) {
    if (document.getElementById(id)) return;
    const s = document.createElement('style');
    s.id = id; s.textContent = css;
    document.head.appendChild(s);
  }

  injectOnce('rcat-styles', `
  .recommended-categories .rcat__title{ margin:0; }
  .recommended-categories .rcat-header{ display:flex; align-items:center; justify-content:space-between; gap:12px; margin:0 0 16px 0; }
  @media (max-width:600px){ .recommended-categories .rcat-header{ flex-wrap:wrap; row-gap:8px; } }
  .recommended-categories .rcat-grid{ display:grid; grid-template-columns: repeat(4, minmax(0,1fr)); grid-auto-rows: 1fr; gap:18px; }
  @media (max-width:990px){ .recommended-categories .rcat-grid{ grid-template-columns: repeat(2, minmax(0,1fr)); } }
  @media (max-width:600px){ .recommended-categories .rcat-grid{ grid-template-columns: 1fr; } }
  .recommended-categories .rcat-col{ display:flex; flex-direction:column; gap:18px; min-width:0; }
  .recommended-categories .rcat{ border:0; background:transparent; padding:0; }
  .recommended-categories .rcat__summary{ list-style:none; display:inline-flex; align-items:center; gap:8px; padding:8px 0; cursor:pointer; }
  .recommended-categories .rcat__summary::-webkit-details-marker{ display:none; }
  .recommended-categories .rcat__label{ text-decoration:none; }
  .recommended-categories .rcat__chev{ transition:transform .2s ease; }
  .recommended-categories details[open] .rcat__chev{ transform: rotate(180deg); }
  .recommended-categories .rcat__list{ margin:8px 0 0 22px; padding:0; }
  .recommended-categories .rcat__item{ list-style:none; margin:8px 0; }
  .recommended-categories .rcat__item a{ text-decoration:none; }
  .recommended-categories .rcat-grid-wrap{ position:relative; overflow:hidden; transition:max-height .45s ease; }
  .recommended-categories .rcat-grid-wrap:not(.is-open)::after{ content:""; position:absolute; left:0; right:0; bottom:0; height:56px; pointer-events:none; background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(var(--color-background,255,255,255),1)); }
  .seo-pill-btn{ display:inline-flex; align-items:center; gap:6px; background-color:#fff; border:1px solid #ddd; border-radius:9999px; padding:8px 20px; font-size:10px; font-weight:400; letter-spacing:0.05em; text-transform:uppercase; cursor:pointer; transition:background-color .2s ease, border-color .2s ease; }
  .seo-pill-btn:hover{ background-color:#f9f9f9; border-color:#ccc; }
  .seo-toggle-icon{ transition:transform .3s ease; }
  .seo-pill-btn.open .seo-toggle-icon{ transform:rotate(180deg); }
  `);

  function chevron() {
    return `
      <svg class="rcat__chev" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
           viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>`;
  }

  function renderCat(c) {
    const label = c.url ? `<a class="rcat__label" href="${c.url}">${c.label}</a>` : `<span class="rcat__label">${c.label}</span>`;
    const list  = (c.subLinks||[]).length
      ? `<ul class="rcat__list">${c.subLinks.map(s=>`<li class="rcat__item">${s.url?`<a href="${s.url}">${s.label}</a>`:`<span>${s.label}</span>`}</li>`).join("")}</ul>`
      : "";
    const summary = `
      <summary class="rcat__summary">
        ${label}
        ${(c.subLinks||[]).length ? chevron() : ""}
      </summary>`;
    return `<details class="rcat">${summary}${list}</details>`;
  }

  function columnsForWidth(w){ if (w <= 600) return 1; if (w <= 990) return 2; return 4; }

  function mount(root) {
    if (!root || root.dataset.rcatInitialized === '1') return;

    function render(columnsCount){
      const cols = Array.from({length: columnsCount}, ()=>[]);
      CATS.forEach((c, i)=> cols[i % columnsCount].push(c));

      const colsHTML = cols.map(col => `
        <div class="rcat-col">
          ${col.map(renderCat).join("")}
        </div>
      `).join("");

      root.innerHTML = `
        <div class="rcat-header">
          <h4 class="rcat__title">${SECTION_TITLE}</h4>
          <button id="rcat-toggle" class="seo-pill-btn" type="button" aria-expanded="false">
            <span class="seo-toggle-text">Zobacz wszystkie</span>
            <svg class="seo-toggle-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
          </button>
        </div>

        <div class="rcat-grid-wrap" id="rcat-grid-wrap">
          <div class="rcat-grid" id="rcat-grid">
            ${colsHTML}
          </div>
        </div>
      `;

      const btn    = root.querySelector('#rcat-toggle');
      const textEl = btn.querySelector('.seo-toggle-text');
      const wrap   = root.querySelector('#rcat-grid-wrap');
      const grid   = root.querySelector('#rcat-grid');
      let isOpen = false;

      function calcCollapsedHeight(){
        const firstInCols = Array.from(grid.querySelectorAll('.rcat-col')).map(col => col.querySelector('.rcat'));
        const heights = firstInCols.filter(Boolean).map(el => el.offsetHeight);
        const ref = heights.length ? Math.max(...heights) : 100;
        const rowsVisible = 1.6;
        const gap = 18;
        return Math.round(ref * rowsVisible + gap * 2);
      }
      function setCollapsed(){
        wrap.classList.remove('is-open');
        wrap.style.maxHeight = calcCollapsedHeight() + 'px';
        btn.classList.remove('open');
        btn.setAttribute('aria-expanded','false');
        textEl.textContent = 'Zobacz wszystkie';
        isOpen = false;
      }
      function setExpanded(){
        wrap.classList.add('is-open');
        wrap.style.maxHeight = grid.scrollHeight + 'px';
        btn.classList.add('open');
        btn.setAttribute('aria-expanded','true');
        textEl.textContent = 'Pokaż mniej';
        const onEnd = (e)=>{ if(e.propertyName==='max-height'){ wrap.style.maxHeight='none'; wrap.removeEventListener('transitionend', onEnd);} };
        wrap.addEventListener('transitionend', onEnd);
        isOpen = true;
      }
      btn.addEventListener('click', ()=> isOpen ? setCollapsed() : setExpanded());
      setCollapsed();
    }

    let currentCols = columnsForWidth(window.innerWidth);
    render(currentCols);

    const onResize = () => {
      const cols = columnsForWidth(window.innerWidth);
      if (cols !== currentCols){
        currentCols = cols;
        render(currentCols);
      }
    };
    window.addEventListener('resize', onResize);

    // Zabezpieczenie przed wielokrotną inicjalizacją
    root.dataset.rcatInitialized = '1';
  }

  function initAll() {
    document.querySelectorAll('[data-rcat-root]').forEach(mount);
  }

  // Obsługa DOM + dynamicznych sekcji Shopify
  const run = () => initAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  document.addEventListener('shopify:section:load', run);
})();
